<template>
  <div>
    <div class="compare-inner-container" v-if="packagesList.length > 0">
      <!-- Piture -->
      <table class="compare-packages-table">
        <tbody>
          <tr>
            <td v-for="pkg in packagesList" :key="pkg.packageId">
              <div class="package-picture-container">
                <div class="package-picture-box">
                  <span class="remove-package" @click="removePkgFromCompare(pkg)">&times;</span>
                  <p class="remove-package-tooltip">Remove package from comparison</p>
                  <a>
                    <img :src="pkg.defaultSrpimg" />
                  </a>
                </div>
                <p class="package-title" v-text="pkg.packageTitle"></p>
                <div class="package-naming-container">
                  <div class="compare-seller-name">
                    <span class="seller-title">Seller:</span>
                    <span class="seller-name" v-text="pkg.vendorName"></span>
                  </div>
                  <span class="pkg-duration">
                    {{pkg.packageDuration}} Night / {{pkg.packageDuration + 1}} Days
                  </span>
                </div>
              </div>
            </td>

            <td v-if="packagesList.length != maxNoOfPackages" v-for="count in packagesList ? 3 - packagesList.length : 0" :key="count">
              <div class="package-picture-container">
                <div class="package-picture-box">
                  <a>
                    <img src="../../static/Images/deafult-pkg-picture.png" alt="default" @click="closeCompare" class="no-package" />
                  </a>
                </div>

              </div>
            </td>
            <!-- </div> -->
          </tr>

          <!-- package type-->
          <!-- <div class="package-flex-container"> -->
          <tr>
            <td v-for="(pkg, $index) in packagesList" :key="pkg.packageId">
              <div class="package-type-container">
                <p class="title" :style="{'visibility': $index === 0 ? 'visible' : 'hidden'}">Package Type</p>
                <p class="pkg-typ">
                  <i :class="getPackageTypeIcon(pkg.tourType)"></i>
                  <span class="pkg-name" v-text="pkg.tourType"></span>
                </p>
              </div>
            </td>
            <td v-if="packagesList.length != maxNoOfPackages" v-for="count in packagesList ? 3 - packagesList.length : 0" :key="count">
              <div class="package-type-container">
              </div>
            </td>
          </tr>
          <!-- </div> -->

          <!-- inclusions -->
          <!-- <div class="package-flex-container"> -->
          <tr>
            <td v-for="(pkg, $index) in packagesList" :key="pkg.packageId">
              <div class="package-inclusions package-inclusions-container">
                <p class="title" :style="{'visibility': $index === 0 ? 'visible' : 'hidden'}">Package Inclusions</p>
                <ul>
                  <template v-for="(inclusion, index) in pkg.packageInclusionTypes">
                    <br v-if="index == 3" :key="inclusion" />
                    <li :key="inclusion">
                      <template v-if="inclusion === 'Flights'">
                        <p class="icon-top flight-ico">
                          <i class="icon icon-flight"></i>
                        </p>
                        <p class="icon-name" v-text="pkg.travelBy && pkg.travelBy.toLowerCase() == 'airland' ? 'Flights' : 'Optional'"></p>
                      </template>
                      <template v-else>
                        <p class="icon-top">
                          <i class="icon" :class="'icon-' + inclusionClass[inclusion]"></i>
                        </p>
                        <p class="icon-name" v-text="inclusion == 'Accommodation' ? 'Hotel' : inclusion"></p>
                      </template>
                    </li>
                  </template>
                </ul>
              </div>
            </td>
            <td v-if="packagesList.length != maxNoOfPackages" v-for="count in packagesList ? 3 - packagesList.length : 0" :key="count">
              <div class="package-inclusions-container">
              </div>
            </td>
          </tr>
          <!-- </div> -->

          <!-- Transport container -->
          <!-- <div class="package-flex-container"> -->
          <tr>
            <td v-for="(pkg, $index) in packagesList" :key="pkg.packageId">
              <div class="package-transport-container">
                <p class="title" :style="{'visibility': $index === 0 ? 'visible' : 'hidden'}">Transport</p>
                <p v-if="!pkg.packageDepartureTransport" class="no-result" :style="{'padding-top': $index === 0 ? 20 : 0}">No transport included</p>
                <div class="travel-container" v-for="transport in pkg.packageDepartureTransport" :key="transport[0].$$hashKey">
                  <div class="flight-logo-box">
                    <i class="air-logo intAirLogo size-28" :class="'x' + transport[0].connectingSegmentsInOrder[0].carrierCode"></i>
                    <p class="flight-number">
                      <span class="flight-name" v-text="transport[0].connectingSegmentsInOrder[0].carrierName"></span>
                      <span class="flight-num" v-if="transport[0].connectingSegmentsInOrder[0].carrierCode && transport[0].connectingSegmentsInOrder[0].carrierNum">{{transport[0].connectingSegmentsInOrder[0].carrierCode + ' - ' + transport[0].connectingSegmentsInOrder[0].carrierNum}}</span>
                    </p>
                  </div>
                  <div class="flight-details">
                    <div class="flight-dep">
                      <p class="dep-city" v-text="transport[0].connectingSegmentsInOrder[0].departureCityCode"></p>
                      <p class="dep-city-full-name" v-text="transport[0].departureCityName"></p>
                    </div>
                    <div class="flight-stops">
                      <div class="two-dots">
                        <span class="one-dot one-stop" v-if="transport[0].connectingSegmentsInOrder.length > 1" v-for="stop in transport[0].connectingSegmentsInOrder.slice(0,transport[0].connectingSegmentsInOrder.length - 1)" :key="stop.$$hashKey"></span>
                      </div>
                      <p class="offer">
                        <span class="stop-name" v-if="transport[0].connectingSegmentsInOrder.length > 1" v-for="stop in transport[0].connectingSegmentsInOrder.slice(0,transport[0].connectingSegmentsInOrder.length - 1)" :key="stop.$$hashKey">Via {{stop.arrivalCityName}}</span>
                      </p>
                    </div>
                    <div class=" flight-dep flight-arr">
                      <p class="arr-city" v-text="transport[0].connectingSegmentsInOrder[0].arrivalCityCode"></p>
                      <p class="arr-city-full-name" v-text="transport[0].arrivalCityName"></p>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td v-if="packagesList.length != maxNoOfPackages" v-for="count in packagesList ? 3 - packagesList.length : 0" :key="count">
              <div class="package-transport-container">
              </div>
            </td>
          </tr>
          <!-- </div> -->

          <!-- Cities and hotels-->
          <!-- <div class="package-flex-container"> -->
          <tr>
            <td v-for="(pkg, $index) in packagesList" :key="pkg.packageId">
              <div class="package-visits-container">
                <p class="title" :style="{'visibility': $index === 0 ? 'visible' : 'hidden'}"> Cities to visit &amp; Hotels Info</p>
                <fieldset v-for="(hotel, key) in pkg.packageAccomodation" :key="key">
                  <legend>
                    {{hotel.city}}
                    <span>( {{hotel.stayDays.noOfNights}} Night )</span>
                  </legend>
                  <p class="hotel-name">
                    {{hotel.hotelName}}
                  </p>
                  <div class="ratings-block">
                    <div class="package-ratings" v-if="hotel.starRating">
                      <i class="icon-full-star" v-for="n in Math.floor(hotel.starRating)" :key="n"></i>
                      <i v-if="hotel.starRating - Math.floor(hotel.starRating) > 0" class="icon-half-star"></i>
                    </div>
                    <div class="rating-partition" v-if="hotel.starRating && hotel.ratingImage"></div>
                    <div class="hotel-rating">
                      <img v-if="hotel.ratingImage" :src="hotel.ratingImage" />
                    </div>
                  </div>
                </fieldset>
              </div>
            </td>
            <td v-if="packagesList.length != maxNoOfPackages" v-for="count in packagesList ? 3 - packagesList.length : 0" :key="count">
              <div class="package-visits-container">
              </div>
            </td>
          </tr>
          <!-- </div> -->

          <!-- Hotels -->
          <!-- <div class="package-flex-container"> -->
          <tr>
            <td v-for="(pkg, $index) in packagesList" :key="$index">
              <div class="package-hotels-container">
                <p class="title" :style="{'visibility': $index === 0 ? 'visible' : 'hidden'}"> Meals</p>
                <div class="meals-include">
                  <p v-if="Object.keys(pkg.perDayMeals).length == 0" class="no-result">No meals included</p>
                  <template v-else>
                    <div class="day-wise" v-for="(dayMeal, day) in pkg.perDayMeals" :key="day">
                      <p class="day">Day {{day}}</p>
                      <p class="inclusions">
                        <span v-text="dayMeal[0]"></span>
                        <span v-for="meal in Object.keys(dayMeal).splice(1)" :key="meal" v-text="'and' + dayMeal[meal]"></span>
                      </p>
                    </div>
                  </template>
                </div>
              </div>
            </td>
            <td v-if="packagesList.length != maxNoOfPackages" v-for="count in packagesList ? 3 - packagesList.length : 0" :key="count">
              <div class="package-hotels-container">
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- </div> -->

      <!-- <div class="compare-popup-container">
      <div class="package-picture-container">
        <div class="package-picture-box">
          <a href="#">
            <img src="../../static/Images/deafult-pkg-picture.png" alt="default" />
          </a>
        </div>

      </div>

      <div class="compare-popup-footer">

      </div>
    </div> -->
    </div>
    <!-- Footer -->
    <div class="compare-footer-container">
      <div class="compare-popup-footer" v-for="pkg in packagesList" :key="pkg.packageId">
        <div class="amount-container">
          <p class="amount-total">
            <i class="rs">RS</i>{{pkg.startFromPrice | format-amount}}</p>
          <span class="people">per person on twin sharing</span>
        </div>
        <button type="button" class="btn btn-primary" @click="goToDetailsPage(pkg.packageId)">view details</button>
      </div>
      <template v-if="packagesList.length != maxNoOfPackages">
        <div class="compare-popup-footer" v-for="count in packagesList ? 3 - packagesList.length : 0" :key="count">
        </div>
      </template>
    </div>
  </div>

  <!-- </div> -->
  <!-- </div> -->
</template>

<script>
import cookie from '../common/cookie'
// import axios from 'axios'

export default {
  props: ['packagesData'],
  mixins: [cookie],
  data: function() {
    return {
      inclusionClass: {
        Accommodation: 'beds',
        Flights: 'flight',
        Transfer: 'transfers',
        Sightseeing: 'sightseeing',
        Meals: 'meals',
        Volvo: 'bus'
      },
      maxNoOfPackages: 3,
      packagesList: [],
      packageinclusionsClasses: {
        Flight: { class: 'icon-flight', name: 'Flight' },
        Accommodation: { class: 'icon-hotel', name: 'Hotel' },
        Meals: { class: 'icon-meals', name: 'Meals' },
        Sightseeing: { class: 'icon-sightseeing', name: 'Sightseeing' }
      }
    }
  },
  created: function() {
    this.packagesList = [] // Object.keys(this.packagesData)
    for (var key in this.packagesData) {
      let currentPkg = this.packagesData[key]
      currentPkg.packageId = key
      this.packagesList.push(currentPkg)
    }

    if (this.packagesList.length > 0) {
      this.packagesList.forEach(pkg => {
        this.setMeals(pkg)
      })
    }

    Array.prototype.uniqueConcat = function(arr) {
      arr.forEach(ele => {
        if (this.indexOf(ele) === -1) {
          this.push(ele)
        }
      })
    }
  },
  methods: {
    goToDetailsPage: function(packageId) {
      let detailsURL = 'details.htm?packageId=' + packageId
      if (window.globalConfig.parentPageIdVal) {
        detailsURL = detailsURL + '&parentPageId=' + window.globalConfig.parentPageIdVal
      }
      window.location.href = detailsURL
    },
    closeCompare: function() {
      this.$emit('closeSlideout')
    },
    getPackageTypeIcon: function(packageType) {
      switch (packageType) {
        case 'Group Tour':
          return 'icon-group'
        case 'Customizable Tour':
          return 'icon-customizable'
        case 'Yatra Special':
          return 'icon-group icon-yatra-special'
      }
    },
    setMeals: function(pkg) {
      let mealsList = {}
      pkg.destinationVsDaysComponents.forEach(destination => {
        for (let day in destination.dayNumVsComponents) {
          if (destination.dayNumVsComponents[day].meals && destination.dayNumVsComponents[day].meals.length > 0) {
            if (mealsList[day]) {
              mealsList.uniqueConcat(destination.dayNumVsComponents[day].meals)
            } else {
              mealsList[day] = destination.dayNumVsComponents[day].meals
            }
          }
        }
      })
      pkg.perDayMeals = mealsList
    },
    removePkgFromCompare: function(pkg) {
      // remove package from cookie
      this.addOrRemoveShortList(pkg)

      // remove package from display
      this.packagesList.splice(this.packagesList.indexOf(pkg), 1)

      // update tuples
      this.$emit('packageCompareToggled')

      // if no packages to display close slideout
      if (this.packagesList.length == 0) {
        this.$emit('closeSlideout')
      }
    }
  }
}
</script>

<style lang="scss">
.no-package {
  cursor: pointer;
}

.no-result {
  margin-top: 20px;
}

.remove-package {
  padding: 0 5px;
  position: absolute;
  right: -10px;
  color: #fff;
  background: #000;
  top: -10px;
  border-radius: 50%;
  height: 20px;
  font-size: 14px;
  width: 20px;
  text-align: center;
  cursor: pointer;
  line-height: 19px;
}

.xnull {
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 4px;
}

.remove-package-tooltip {
  background: #000;
  color: #fff;
  max-width: 140px;
  font-size: 13px;
  text-align: center;
  padding: 5px 10px;
  border-radius: 4px;
  position: absolute;
  right: -10px;
  top: 12px;
  display: none;
}

.remove-package:hover + .remove-package-tooltip {
  display: initial;
}

.compare-seller-name {
  max-width: 170px;
  word-wrap: break-word;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/compare-packages.vue